import { NgModule } from '@angular/core';
import { EventTrackerSnippetScriptService } from './event-tracker-snippet-script.service';


@NgModule({
    providers: [
        EventTrackerSnippetScriptService
    ]
})

export class EventTrackerModule {
}
